import { Config } from '../config/Config';

/** True when the current URL is the app home route (`/` relative to `Config.BASE_URL`). */
export function isAppHomePath(pathname?: string): boolean {
  if (typeof window === 'undefined') return false;

  const base = String(Config.BASE_URL || '').replace(/\/$/, '');
  let path = pathname ?? window.location.pathname;

  if (base && (path === base || path.startsWith(`${base}/`))) {
    path = path.slice(base.length) || '/';
  }

  path = path.replace(/\/$/, '') || '/';
  return path === '/';
}

/** True on My Quotes or My Orders list routes. */
export function isAppListPagePath(pathname?: string): boolean {
  if (typeof window === 'undefined') return false;

  const base = String(Config.BASE_URL || '').replace(/\/$/, '');
  let path = pathname ?? window.location.pathname;

  if (base && (path === base || path.startsWith(`${base}/`))) {
    path = path.slice(base.length) || '/';
  }

  path = path.replace(/\/$/, '') || '/';
  return path === '/my-quotation' || path === '/order';
}

/**
 * Onboarding/auth screens that show their own BrandedLoader — skip App-level FrontLoader
 * during profile bootstrap to avoid duplicate logo loaders.
 */
export function isAppOnboardingLoaderPath(pathname?: string): boolean {
  if (typeof window === 'undefined') return false;

  const base = String(Config.BASE_URL || '').replace(/\/$/, '');
  let path = pathname ?? window.location.pathname;

  if (base && (path === base || path.startsWith(`${base}/`))) {
    path = path.slice(base.length) || '/';
  }

  return (
    path.includes('/signup/complete-profile') ||
    path.endsWith('/category') ||
    path.endsWith('/update-category')
  );
}
